// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import footprintImage from "common/img/results-footprint.jpg";

import AverageFootprint from "./AverageFootprint";
import FootprintEquivalences from "./FootprintEquivalences";

import Section from "../styled-components/Section";
import SectionContent from "../styled-components/SectionContent";
import SectionTitle from "../styled-components/SectionTitle";
import SectionImage from "../styled-components/SectionImage";
import SectionTitleSeparator from "../styled-components/SectionTitleSeparator";

interface SummaryProps {
  userFootprint: number;
  averageFootprint: number;
  treeEquivalence: number;
  carEquivalence: number;
}

function Summary({
  userFootprint,
  averageFootprint,
  treeEquivalence,
  carEquivalence,
}: SummaryProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  return (
    <Section>
      <SectionImage
        basis={upDesktopScreen ? "53%" : "303px"}
        src={footprintImage}
      />
      <SectionContent>
        <SectionTitle position="right">
          Huella de carbono
          {upDesktopScreen && <SectionTitleSeparator position="right" />}
        </SectionTitle>
        <AverageFootprint
          userFootprint={userFootprint}
          averageFootprint={averageFootprint}
        />
        <FootprintEquivalences
          treeEquivalence={treeEquivalence}
          carEquivalence={carEquivalence}
          userFootprint={userFootprint}
        />
      </SectionContent>
    </Section>
  );
}

export default Summary;
